interface LoaderProps {
  size: number;
}

function Loader({ size }: LoaderProps) {
  return (
    <div className="spinner-outer" data-size={size}>
      <div className="spinner-inner"></div>
    </div>
  );
}

export default Loader;
